<div id="CANVAS_CONTAINER" class="d-flex flex-column">
    <div class="d-flex">
        <label class="my-auto">Signature</label>
        <button type="button" class="btn btn-sm btn-primary ms-auto" (click)="eraseCanvas();">Clear</button>
    </div>
    <canvas id="SIGNATURE_CANVAS" class="mt-1" style="border: 1px solid #CED4DA; border-radius: 0.375rem; touch-action: none;"></canvas>
</div>